import { render, staticRenderFns } from "./order-product-tabs-table.vue?vue&type=template&id=626961be&scoped=true"
import script from "./order-product-tabs-table.vue?vue&type=script&lang=ts"
export * from "./order-product-tabs-table.vue?vue&type=script&lang=ts"
import style0 from "./order-product-tabs-table.vue?vue&type=style&index=0&id=626961be&prod&lang=css"
import style1 from "./order-product-tabs-table.vue?vue&type=style&index=1&id=626961be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626961be",
  null
  
)

export default component.exports